export default (() => {
  function flatten(array: unknown[][]): unknown[] {
    if (!array?.length || !array) return array;

    const res = [];

    for (let i = 0; i < array?.length; i++) {
      if (Array.isArray(array[i])) {
        const flat: unknown[] = flatten(array[i] as unknown[][]);

        for (let j = 0; j < flat.length; j++) {
          res.push(flat[j]);
        }
      } else {
        res.push(array[i]);
      }
    }

    return res;
  }

  function uniqueByKey<T>(key: keyof T, array: T[]): T[] {
    const flags: { [key: string]: any } = {};
    const output = [];
    const length = array?.length;

    for (let index = 0; index < length; index++) {
      const value = array[index][key] as string;

      if (!Object.hasOwnProperty?.call(flags, value)) {
        flags[value] = true;
        output.push(array[index]);
      }
    }

    return output;
  }

  return {
    uniqueByKey,
    flatten,
  };
})();
